<sl-input
    #calendarInput
    id="calendar"
    ngDefaultControl
    type="date"
    [name]="key"
    [label]="props.label | htmlDecode"
    [disabled]="props.readonly || false" 
    [required]="props.required || false"
    [shoelaceReadonly]="props.readonly"
    [formControl]="formControl" 
    [formlyAttributes]="field">

    <sl-icon slot="suffix" name="calendar3"></sl-icon>
</sl-input>